import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  uniq, map, find, cloneDeep,
  each, sortBy,
} from 'lodash';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { format as formatMoney } from '../../../../components/money-display';

import {
  getWinLossOpportunities,
} from '../../../Dashboard/DashboardReducer';
import DropdownRange from '../../../../components/dropdown-range';
import { getHasNoDecisionSetup } from '../../../../components/search-form/search-form-reducer';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import Pie from '../../../Analysic/components/graphs/pie';
import styles from './styles.css';

const USER_PREFERENCE_REPORT_TYPE = 'leaderboard-size-graph-report-type';

export function getDefautlIndexFromTotal(total) {
  const lowerIndex = Math.floor((total / 3) - 1);
  const upperIndex = Math.floor((2 * (total / 3)) - 1);
  return [lowerIndex, upperIndex];
}

export function getAmountIndexFromBuckets(buckets = []) {
  return uniq(map(sortBy(buckets, b => b.amount), item => Math.round(item.amount * 100) / 100));
}

export function getBreakDownBuckets(buckets, amountIndex, minIndex, maxIndex) {
  const lowerAmount = amountIndex[minIndex];
  const upperAmount = amountIndex[maxIndex];

  const oneStat = {
    total: 0,
    amount: 0,
    min: null,
    max: 0,
    stats: {
      won: { total: 0, amount: 0, opportunityIds: [], unit: 'with Request' },
      lost: { total: 0, amount: 0, opportunityIds: [], unit: 'without Request' },
    },
  };

  const results = {
    large: cloneDeep(oneStat),
    medium: cloneDeep(oneStat),
    small: cloneDeep(oneStat),
    total: cloneDeep(oneStat),
  };
  each(buckets, (item) => {
    let bucketType = 'medium';
    if (item.amount <= lowerAmount) {
      bucketType = 'small';
    } else if (item.amount >= upperAmount) {
      bucketType = 'large';
    }
    each([bucketType, 'total'], (type) => {
      const bucket = results[type];
      const stage = item.has_requests ? 'won' : 'lost';
      if (bucket.stats[stage]) {
        bucket.amount += item.amount;
        bucket.max = Math.max(bucket.max, item.amount);
        if (bucket.min === null) {
          bucket.min = item.amount;
        } else {
          bucket.min = Math.min(bucket.min, item.amount);
        }
        bucket.total += 1;
        bucket.stats[stage].total += 1;
        bucket.stats[stage].amount += item.amount || 0;
        bucket.stats[stage].opportunityIds.push(item.opportunity_id);
      }
    });
  });
  return results;
}


class DealSizeChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportType: 'amount',
      amountIndex: [],
      bounds: [0, 0],
      buckets: null,
    };
    this.onSliderChange = this.onSliderChange.bind(this);
    this.setReportType = this.setReportType.bind(this);
  }

  componentWillMount() {
    const { opportunities } = this.props;
    const reportType = this.context.getUserPreference(USER_PREFERENCE_REPORT_TYPE, 'amount');
    const amountIndex = getAmountIndexFromBuckets(opportunities);
    const total = amountIndex.length;
    const bounds = getDefautlIndexFromTotal(total);
    this.setState({ reportType, amountIndex, bounds }, this.calculate);
  }


  onSliderChange(bounds) {
    this.setState({ bounds }, this.calculate);
  }

  getBucketSubTitle(bucket) {
    const { organization } = this.props;
    let suffix = '';
    let symbol = '';
    if (organization) {
      suffix = organization.currency_suffix;
      symbol = organization.currency_symbol;
    }
    const min = formatMoney(bucket.min, true, 1, symbol);
    const max = formatMoney(bucket.max, true, 1, symbol, suffix);
    return `${min} - ${max}`;
  }

  getBucketTitle(title, bucket) {
    const titleSuffix = `DEAL${(bucket.total !== 1 ? 'S' : '')}`;
    return `${title} ${titleSuffix}`;
  }

  setReportType(reportType) {
    this.setState({ reportType }, this.calculate);
    this.context.updateUserPreference(USER_PREFERENCE_REPORT_TYPE, reportType);
  }

  calculate() {
    const { opportunities } = this.props;
    const { amountIndex, bounds } = this.state;
    const buckets = getBreakDownBuckets(opportunities, amountIndex, bounds[0], bounds[1]);
    this.setState({ buckets });
  }

  render() {
    const {
      reportType, buckets, amountIndex,
      bounds,
    } = this.state;
    const { organization, hasNoDecisionSetup } = this.props;
    const reportTypes = [
      { value: 'amount', label: 'Amount' },
      { value: 'count', label: 'Count' },
    ];
    let fieldSuffix = '';
    let fieldPrefix = '';
    if (organization) {
      fieldSuffix = organization.currency_suffix;
      fieldPrefix = organization.currency_symbol;
    }

    const activeReportType = find(reportTypes, { value: reportType }) || { label: 'Amount' };
    return (
      <div className="animated fadeIn">
        <div>
          <h5 className="sub-header-with-controls">
            View
            {' '}
            <Dropdown
              id="leaderboard-bucket-report-type-dropdown"
            >
              <Dropdown.Toggle bsSize="small">
                {activeReportType.label}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {reportTypes.map(s => (
                  <MenuItem
                    key={s.value}
                    active={s.value === reportType}
                    onSelect={() => { this.setReportType(s.value); }}
                  >
                    {s.label}
                  </MenuItem>
                  ))}
              </Dropdown.Menu>
            </Dropdown>
            {' '}
            feedback request rates in small, medium, and large deal sized with boundaries
            {' '}
            {buckets !== null && buckets.total.total && <DropdownRange
              values={amountIndex}
              bounds={bounds}
              onSliderChange={this.onSliderChange}
              modalProps={{
                fieldPrefix,
                fieldSuffix,
                title: 'Small, Medium and Large Deal Size Boundaries',
                lowerLabel: 'Medium Size Start',
                upperLabel: 'Large Size Start',
              }}
            />}
          </h5>

          {buckets !== null &&
            <div className={`row ${styles.opportunityGraphs}`}>
              <div className="col-sm-4">
                <Pie
                  reportType={reportType}
                  bucket={buckets.small}
                  type="small"
                  hasNoDecisionSetup={hasNoDecisionSetup}
                  subTitle={this.getBucketSubTitle(buckets.small)}
                  title={this.getBucketTitle('SMALL', buckets.small)}
                  onChartSegmentSelect={this.props.onOpportunitySelect}
                />
              </div>
              <div className="col-sm-4">
                <Pie
                  reportType={reportType}
                  bucket={buckets.medium}
                  type="medium"
                  hasNoDecisionSetup={hasNoDecisionSetup}
                  subTitle={this.getBucketSubTitle(buckets.medium)}
                  title={this.getBucketTitle('MEDIUM', buckets.medium)}
                  onChartSegmentSelect={this.props.onOpportunitySelect}
                />
              </div>
              <div className="col-sm-4">
                <Pie
                  reportType={reportType}
                  bucket={buckets.large}
                  type="large"
                  hasNoDecisionSetup={hasNoDecisionSetup}
                  subTitle={this.getBucketSubTitle(buckets.large)}
                  title={this.getBucketTitle('LARGE', buckets.large)}
                  onChartSegmentSelect={this.props.onOpportunitySelect}
                />
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}


DealSizeChart.propTypes = {
  opportunities: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  hasNoDecisionSetup: PropTypes.bool.isRequired,
  organization: PropTypes.shape({}).isRequired,
  onOpportunitySelect: PropTypes.func,
};

DealSizeChart.defaultProps = {
  onOpportunitySelect: () => {},
};

DealSizeChart.contextTypes = {
  updateUserPreference: PropTypes.func.isRequired,
  getUserPreference: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    opportunities: getWinLossOpportunities(state),
    hasNoDecisionSetup: getHasNoDecisionSetup(state),
    organization: getUserCurrentOrganization(state),
  };
}

export default connect(mapStateToProps)(DealSizeChart);;
